var _ = require('underscore');
var AccordionWidget = require('./../widget/accordion/AccordionWidget');
var payableBillsAccordionTemplate = require('./payableBillsAccordionTemplate.hbs');
var PayableBillsListWidget = require('./PayableBillsListWidget');

/**
 * Displays the payable bills accordion as a list item.
 *
 * @class PayableBillsAccordionWidget
 * @extends Torso.View
 * @constructor
 */
module.exports = AccordionWidget.extend({
  template: payableBillsAccordionTemplate,

  accordionId: 'payable-bills-accordion',
  asListItem: true,
  contentNoPadding: true,
  noTriggerView: true,

  prepareFields: _.defaults({
    hasPayableBills: 'hasPayableBills',
    payableBillsCount: 'getPayableBillsCount',
    payableBillsAmount: 'getTotalUnpaidBillsAmount'
  }, AccordionWidget.prototype.prepareFields),

  /**
   * @method hasPayableBills
   * @return {Boolean} true if the fetched payable bills exist, false otherwise.
   */
  hasPayableBills: function() {
    return this._payableBillsListWidget && this._payableBillsListWidget.hasPayableBills();
  },

  /**
   * @method getPayableBillsCount
   * @returns {Number} the number of payable bills fetched from the server.  returns 0 if none have been fetched.
   */
  getPayableBillsCount: function() {
    return this._payableBillsListWidget && this._payableBillsListWidget.getPayableBillsCount();
  },

  /**
   * @method getTotalUnpaidBillsAmount
   * @returns {Number} the total amount that the patient has in unpaid bills.
   */
  getTotalUnpaidBillsAmount: function () {
    return this._payableBillsListWidget && this._payableBillsListWidget.getTotalUnpaidBillsAmount();
  },

  /**
   * @method hasBillsWithoutAccountNumber
   * @returns {boolean} true if there are any bills without account number
   */
  hasBillsWithoutAccountNumber: function() {
    return this._payableBillsListWidget && this._payableBillsListWidget.hasBillsWithoutAccountNumber();
  },

  /**
   * @method allBillsWithoutAccountNumber
   * @returns {boolean} true if all the bills are without account number
   */
  allBillsWithoutAccountNumber: function() {
    return this._payableBillsListWidget && this._payableBillsListWidget.allBillsWithoutAccountNumber();
  },

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    this._payableBillsListWidget = new PayableBillsListWidget();
    this.registerTrackedView(this._payableBillsListWidget);
    this.listenTo(this._payableBillsListWidget, 'change:totalUnpaidBillsAmount', function() {
      this.trigger('change:totalUnpaidBillsAmount');
    });
    this._accordionContentView = this._payableBillsListWidget;
  }
});
